module.exports = __webpack_public_path__ + "static/media/sound-wave.10843549.gif";